import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api, formatApiErrorDetail } from "../../lib/api";
import ReportFilters, { EMPTY_FILTERS } from "../../components/reports/ReportFilters";
import ReportRowsTable from "../../components/reports/ReportRowsTable";

export default function VehicleRegistrationReport() {
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async (f = filters) => {
    setLoading(true);
    try {
      // Drop blank params
      const params = {};
      Object.entries(f).forEach(([k, v]) => {
        if (v) params[k] = v;
      });
      const { data } = await api.get("/reports/vehicle-registration", { params });
      setRows(data || []);
    } catch (e) {
      toast.error(
        formatApiErrorDetail(e?.response?.data?.detail) ||
          "Failed to load vehicle registration report"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load(EMPTY_FILTERS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onReset = () => {
    setFilters(EMPTY_FILTERS);
    load(EMPTY_FILTERS);
  };

  return (
    <div data-testid="vehicle-registration-report-page">
      <header className="bg-white border-b border-black/5 px-8 py-5 flex items-center justify-between gap-3">
        <div>
          <h1 className="text-xl font-semibold text-[#0A0A0A] tracking-tight">
            Master Vehicle Registration Report
          </h1>
          <p className="text-xs text-[#525252] mt-0.5">
            All completed fuel access registrations. Use filters to narrow down by date, user and location.
          </p>
        </div>
      </header>

      <div className="p-8">
        <ReportFilters
          userLabel="Registered By"
          userApiPath="/members"
          value={filters}
          onChange={setFilters}
          onApply={() => load(filters)}
          onReset={onReset}
          loading={loading}
        />

        <ReportRowsTable
          rows={rows}
          loading={loading}
          emptyText="No vehicle registrations found for the selected filters."
        />
      </div>
    </div>
  );
}
